dmx.Component('f7-popup', {

  initialData: {
    opened: false
  },

  attributes: {
    backdrop: {
      type: Boolean,
      default: true,
    },

    closeByBackdropClick: {
      type: Boolean,
      default: true,
    },

    closeOnEscape: {
      type: Boolean,
      default: false,
    },

    animate: {
      type: Boolean,
      default: true,
    },

    swipeToClose: {
      type: Boolean,
      default: false,
    },

    opened: {
      type: Boolean,
      default: false,
    },

    params: {
      type: Object,
      default: {},
    },
  },

  methods: {
    open (animate) {
      if (!this._component) return;
      this._component.open(animate);
    },

    close (animate) {
      if (!this._component) return;
      this._component.close(animate);
    }
  },

  events: {
    open: Event,
    opened: Event,
    close: Event,
    closed: Event
  },

  render (node) {
    node.classList.add('popup');

    dmx.f7.ready(app => {
      const popup = this._component = app.popup.create({
        backdrop: this.props.backdrop,
        closeByBackdropClick: this.props.closeByBackdropClick,
        closeOnEscape: this.props.closeOnEscape,
        animate: this.props.animate,
        swipeToClose: this.props.swipeToClose,
        ...this.props.params,
        el: node,
      });

      this._registerEvents(Object.keys(this.events));

      popup.on('opened', () => {
        this.set('opened', true);
      });

      popup.on('closed', () => {
        this.set('opened', false);
      });

      if (this.props.opened) {
        popup.open(false);
      }
    });

    this.$parse();
  },

  performUpdate (updatedProps) {
    if (this._component) {
      if (updatedProps.has('opened')) {
        this._component[this.props.opened ? 'open' : 'close']();
      }
      this.set('opened', this._component.opened);
    }
  },

  destroy () {
    if (this._component) {
      this._component.destroy();
      delete this._component;
    }
  },

  _registerEvents (events) {
    for (const event of events) {
      this._component.on(event, () => this.dispatchEvent(event));
    }
  },
  
});